<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M14.2853 1.71436L1.71387 14.2858" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.71387 1.71436L14.2853 14.2858" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
